import GameiomModel from "gameiom/model/gameiom-model";
import { UiElements } from "gameiom/wrapper/wrapper-data";
import HomeButtonControl from "slotworks/smart-ui/controls/button/home-button-control";
import ControlOptions from "slotworks/smart-ui/options/control-options";

export default class AgsHomeButtonControl extends HomeButtonControl {

    public updateOptions(options: ControlOptions) {
        this.setVisible(GameiomModel.displayButtons.get(UiElements.homeButton));
        super.updateOptions(options);
    }

    protected onClick() {
        this.options.onSessionClose = () => gameWrapper.exitGame();

        super.onClick();
    }
}
